import md5 from 'blueimp-md5'
export default md5



// WEBPACK FOOTER //
// ./~/vux/src/tools/md5/index.js